// Storefront category labels, shared by the shop and the patient portal's
// "Buy again", which must respect the same one-weight-loss-product cart rule.

/** Raw category slugs mapped to friendly display names. */
const CATEGORY_LABELS: Record<string, string> = {
  'weight-management': 'Weight Loss',
  'weight management': 'Weight Loss',
  'wellness': 'Wellness',
  'dermatology': 'Dermatology',
  'ed': 'Sexual Health',
  'trt': 'Hormone Therapy',
  'bhrt': 'Hormone Therapy',
  'muscle growth': 'Peptides & Recovery',
  'anesthetics': 'Anesthetics',
  'iv kits & premixes': 'IV Therapy',
};

/** Display order for categories. */
export const CATEGORY_ORDER = [
  'Weight Loss',
  'Peptides & Recovery',
  'Hormone Therapy',
  'Wellness',
  'Sexual Health',
  'Dermatology',
  'IV Therapy',
  'Anesthetics',
];

export function getDisplayCategory(categories: string[]): string {
  for (const cat of categories) {
    const label = CATEGORY_LABELS[cat.toLowerCase()];
    if (label) return label;
  }
  return 'Other';
}
